// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-effect-enter-active[data-v-6c9e9a16],.loader-effect-leave-active[data-v-6c9e9a16]{transition:opacity .5s}.loader-effect-enter[data-v-6c9e9a16],.loader-effect-leave-to[data-v-6c9e9a16]{opacity:0}#page-loader[data-v-6c9e9a16]{position:fixed;top:0;left:0;width:100%;height:100%;background:#f8fafc;z-index:18}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
